<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <app-content-title :title="translations.globalSettings" />
      </div>
      <app-settings @submit="submitForm" :disabled="pending">
        <app-settings-content>
          <app-settings-desc :title="translations.basicInfo">
            <p v-translate>Pokud běží na produkčním prostředí, tak tyto úpravy může provádět jenom hlavní administrátor.</p>
          </app-settings-desc>

          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                  required
                  :error="errors.items.find(el => el.field === 'archiveDuration')"
                  v-model="watchedItem.archiveDuration"
                  :label="translations.archiveDuration"
                  name="archiveDuration"
                  type="number"
              />

              <app-settings-select
                  required
                  :error="errors.items.find(el => el.field === 'EPGProcessingEnd')"
                  :label="translations.epgProcessingEnd"
              >
                <app-select
                    :options="enums.epgProcessingEnd"
                    v-model="watchedItem.EPGProcessingEnd"
                    name="EPGProcessingEnd"
                />
              </app-settings-select>

              <app-input
                  required
                  :error="errors.items.find(el => el.field === 'importDuration')"
                  v-model="watchedItem.importDuration"
                  :label="translations.importDuration"
                  name="importDuration"
                  type="number"
              />

                <app-input
                    required
                    :error="errors.items.find(el => el.field === 'ignoredPercentageDropRateNumberOfBroadcasts')"
                    v-model="watchedItem.ignoredPercentageDropRateNumberOfBroadcasts"
                    :label="translations.ignoredPercentageDropRateNumberOfBroadcasts"
                    name="ignoredPercentageDropRateNumberOfBroadcasts"
                    type="number"
                />

                <app-input
                    required
                    :error="errors.items.find(el => el.field === 'numberOfImportedBroadcastsWarningLimit')"
                    v-model="watchedItem.numberOfImportedBroadcastsWarningLimit"
                    :label="translations.numberOfImportedBroadcastsWarningLimit"
                    name="numberOfImportedBroadcastsWarningLimit"
                    type="number"
                />

                <app-input
                    required
                    :error="errors.items.find(el => el.field === 'numberOfImportedBroadcastsErrorLimit')"
                    v-model="watchedItem.numberOfImportedBroadcastsErrorLimit"
                    :label="translations.numberOfImportedBroadcastsErrorLimit"
                    name="numberOfImportedBroadcastsErrorLimit"
                    type="number"
                />
            </app-settings-col>

            <app-settings-col class="field_right">
              <h4 v-translate>Defaultní obrázky broadcastů</h4>
              <app-image-input
                name="defaultPortrait"
                pClass="field field_poster"
                :labelTitle="translations.poster"
                labelClass="poster add_profile_image"
                :text="translations.uploadPoster"
                spanClass="sizes"
                ref="defaultPortrait"
                :image="watchedItem.defaultPortrait"
                :imageLink="portraitLink"
                :disabled="pending"
                :error="!!errors.first('defaultPortrait')"
                @fileChanged="onDefaultPortraitChanged"
              />
              <app-image-input
                name="defaultLandscape"
                pClass="field field_poster"
                :labelTitle="translations.icon"
                labelClass="photo add_profile_image"
                :text="translations.uploadIcon"
                spanClass="sizes"
                ref="defaultLandscape"
                :image="watchedItem.defaultLandscape"
                :imageLink="landscapeLink"
                :disabled="pending"
                :error="!!errors.first('defaultLandscape')"
                @fileChanged="onDefaultLandscapeChanged"
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <h4 v-translate>Defaultní obrázky států</h4>
              <app-image-input
                  name="defaultCountryLandscape"
                  pClass="field field_poster"
                  :labelTitle="translations.defaultCountryLandscape"
                  labelClass="photo add_profile_image"
                  :text="translations.uploadDefaultCountryLandscape"
                  spanClass="sizes"
                  ref="defaultCountryLandscape"
                  :image="watchedItem.defaultCountryLandscape"
                  :imageLink="defaultCountryLandscapeLink"
                  :disabled="pending"
                  :error="!!errors.first('defaultCountryLandscape')"
                  @fileChanged="onDefaultCountryLandscapeChanged"
              />
              <app-image-input
                  name="defaultCountryFlag"
                  pClass="field field_poster"
                  :labelTitle="translations.defaultCountryFlag"
                  labelClass="icon add_profile_image"
                  :text="translations.uploadDefaultCountryFlag"
                  spanClass="sizes"
                  ref="defaultCountryFlag"
                  :image="watchedItem.defaultCountryFlag"
                  :imageLink="defaultCountryFlagLink"
                  :disabled="pending"
                  :error="!!errors.first('defaultCountryFlag')"
                  @fileChanged="onDefaultCountryFlagChanged"
              />
            </app-settings-col>

          </app-settings-options>
        </app-settings-content>

        <app-settings-buttons>
          <app-content-save-button :disabled="pending" @click="disallowBack" />
        </app-settings-buttons>
      </app-settings>
    </form>
  </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import { mapActions } from 'vuex'
import axios from 'axios'
import { GET, UPDATE } from 'constants/api'
import { processFormSubmit, setLoadingMessage } from 'utils/form'
import appTitleMixin from '../mixins/appTitleMixin'
import { VUE_APP_BASE_API_URL } from '../constants/fileConstants'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Settings',
  allowedApiMethods: [GET, UPDATE],
  storeItemName: 'settings',
  enums: true
})

export default {
  name: 'settings',
  mixins: [itemDetailMixin, appTitleMixin(['Nastavení'])],
  data() {
    return {
      watchedItem: {
        archiveDuration: null,
        importDuration: null,
        EPGProcessingEnd: null,
        defaultPortrait: null,
        defaultLandscape: null,
        defaultCountryLandscape: null,
        defaultCountryFlag: null,
        ignoredPercentageDropRateNumberOfBroadcasts: null,
        numberOfImportedBroadcastsWarningLimit: null,
        numberOfImportedBroadcastsErrorLimit: null
      },
      imagesUploading: false,
      defaultPortraitChanged: false,
      defaultLandscapeChanged: false,
      defaultCountryLandscapeChanged: false,
      defaultCountryFlagChanged: false,
      defaultCountryLandscapeLink: '',
      defaultCountryFlagLink: '',
      portraitLink: '',
      landscapeLink: ''
    }
  },
  computed: {
    translations() {
      return {
        globalSettings: this.$gettext('Globální nastavení'),
        basicInfo: this.$gettext('Základní údaje'),
        archiveDuration: this.$gettext('Délka archivu'),
        epgProcessingEnd: this.$gettext('Konec zpracování EPG'),
        importDuration: this.$gettext('Délka zobrazovaného importu'),
        poster: this.$gettext('Poster'),
        uploadPoster: this.$gettext('Nahrát poster'),
        icon: this.$gettext('Ikona'),
        uploadIcon: this.$gettext('Nahrát ikonu'),
        defaultCountryLandscape: this.$gettext('Obrázek na pozadí'),
        defaultCountryFlag: this.$gettext('Vlajka'),
        uploadDefaultCountryLandscape: this.$gettext('Nahrát obrázek na pozadí'),
        uploadDefaultCountryFlag: this.$gettext('Nahrát vlajku'),
        ignoredPercentageDropRateNumberOfBroadcasts: this.$gettext('Ignorovaný úbytek počtu vysílání v procentech'),
        numberOfImportedBroadcastsWarningLimit: this.$gettext('Počet dnů s počtem vysílání pod minimem pro zaslání varovných notifikací'),
        numberOfImportedBroadcastsErrorLimit: this.$gettext('Počet dnů s počtem vysílání pod minimem pro zaslání chybových notifikací')
      }
    },
    currentTitle() {
      return [
        this.$gettext('Nastavení')
      ]
    }
  },
  methods: {
    ...mapActions(['getBroadcastOverview']),
    goBack() {
      this.$router.go(-1)
    },
    copyWatchedItem() {
      Object.keys(this.watchedItem).forEach(v => (this.watchedItem[v] = this.formItem[v]))
    },
    async submitForm(e) {
      this.errors.clear()

      await this.$validator.validateAll()
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg))
        return
      }

      const formData = processFormSubmit(e)

      const response = await this.updateSettings({
        data: {
          ...formData,
          timeZone: 'Europe/Prague'
        }
      }).catch(err => err.response)

      this.handleResponseIfError(response)

      if (this.defaultPortraitChanged || this.defaultLandscapeChanged || this.defaultCountryLandscapeChanged || this.defaultCountryFlagChanged) {
        try {
          this.setImagesUploading(true)

          const { elements } = e.target
          const imageApiUrl = VUE_APP_BASE_API_URL + 'default-images/'

          if (this.defaultPortraitChanged) {
            const formData = new FormData()
            const filePortrait = elements.namedItem('defaultPortrait').files[0]
            if (filePortrait) {
              formData.set('fileExists', true)
              formData.append('file', filePortrait)
            } else {
              formData.set('fileExist', false)
            }

            formData.append('labelId', 0)
            formData.append('type', 'IMAGE_TYPE_PORTRAIT')
            await axios.post(imageApiUrl, formData)
          }

          if (this.defaultLandscapeChanged) {
            const formData = new FormData()
            const fileLandscape = elements.namedItem('defaultLandscape').files[0]
            if (fileLandscape) {
              formData.set('fileExists', true)
              formData.append('file', fileLandscape)
            } else {
              formData.set('fileExists', false)
            }

            formData.append('labelId', 0)
            formData.append('type', 'IMAGE_TYPE_LANDSCAPE')
            await axios.post(imageApiUrl, formData)
          }

          const countryImageApiUrl = VUE_APP_BASE_API_URL + 'country-image/';
          if (this.defaultCountryFlagChanged) {
              const formData = new FormData();
              const defaultCountryFlag = elements.namedItem('defaultCountryFlag').files[0];
              if (defaultCountryFlag) {
                  formData.set('fileExists', true);
                  formData.append('file', defaultCountryFlag);
              } else {
                  formData.set('fileExists', false);
              }

              formData.append('countryId', 0);
              formData.append('imageType', 'IMAGE_TYPE_COUNTRY_FLAG');
              await axios.post(countryImageApiUrl, formData);
          }

          if (this.defaultCountryLandscapeChanged) {
              const formData = new FormData();
              const defaultCountryLandscape = elements.namedItem('defaultCountryLandscape').files[0];
              if (defaultCountryLandscape) {
                  formData.set('fileExists', true);
                  formData.append('file', defaultCountryLandscape);
              } else {
                  formData.set('fileExists', false);
              }

              formData.append('countryId', 0);
              formData.append('imageType', 'IMAGE_TYPE_LANDSCAPE');
              await axios.post(countryImageApiUrl, formData);
          }
        } finally {
          this.setImagesUploading(false)
          this.resetDefaultImagesChanged()
        }
      }

      await this.getBroadcastOverview()

      if (this.backAllowed) {
        this.goBack()
      }
    },
    setImagesUploading(uploading) {
      this.imagesUploading = uploading
      setLoadingMessage(this, uploading ? 'Nahrávání obrázků...' : null)
    },
    resetDefaultImagesChanged() {
      this.defaultPortraitChanged = false
      this.defaultLandscapeChanged = false
    },
    onDefaultPortraitChanged() {
      this.defaultPortraitChanged = true
      this.portraitLink = ''
    },
    onDefaultLandscapeChanged() {
      this.defaultLandscapeChanged = true
      this.landscapeLink = ''
    },
    onDefaultCountryLandscapeChanged() {
      this.defaultCountryLandscapeChanged = true;
      this.defaultCountryLandscapeLink = '';
    },
    onDefaultCountryFlagChanged() {
      this.defaultCountryFlagChanged = true;
      this.defaultCountryFlagLink = '';
    }
  },
  watch: {
    formItem() {
      this.copyWatchedItem()
      if (this.item.defaultImages) {
          if (this.item.defaultImages.IMAGE_TYPE_PORTRAIT) {
              this.portraitLink = this.item.defaultImages.IMAGE_TYPE_PORTRAIT.imageLink
          }
          if (this.item.defaultImages.IMAGE_TYPE_LANDSCAPE) {
              this.landscapeLink = this.item.defaultImages.IMAGE_TYPE_LANDSCAPE.imageLink
          }
      }

      console.warn(this.item.defaultCountryImages);

      if (this.item.defaultCountryImages) {
        if (this.item.defaultCountryImages.IMAGE_TYPE_LANDSCAPE) {
            this.defaultCountryLandscapeLink = this.item.defaultCountryImages.IMAGE_TYPE_LANDSCAPE.imageLink
        }

        if (this.item.defaultCountryImages.IMAGE_TYPE_COUNTRY_FLAG) {
            this.defaultCountryFlagLink = this.item.defaultCountryImages.IMAGE_TYPE_COUNTRY_FLAG.imageLink
        }
      }
    }
  }
}
</script>
